<template>
  <div class="flex flex-col justify-content-end">
    <p class="text-gray-600 text-sm mb-2">{{ __('question.amount_of_answers') }} {{ question.amount_of_answers }}</p>
    <div v-for="(choice, index) in question.choices" :key="index" class="" role="tablist" aria-orientation="vertical">
      <label
          :class="getChoiceClass(choice)"
          class="block mb-2 rounded-lg nav-link p-2 lg:p-4 w-100 flex justify-content-start align-items-start shadow cursor-pointer"
          :for="'q_choice_' + choice.id">
        <input :id="'q_choice_' + choice.id" v-model="selectedChoices" :disabled="!canBeSelected" type="checkbox" name="choices"
               class="mt-1 mr-2 hidden" :value="choice.id">
        <!-- is correct -->
        <i v-if="choice.isCorrect" class="fa fa-check icon--correct w-5 h-5 fill-white"></i>
        <!-- is wrong -->
        <i v-else-if="choice.isWrong" class="fa fa-times icon--wrong w-5 h-5 fill-white"></i>
        <!-- is selected -->
        <icon v-else-if="selectedChoices.includes( choice.id )" style="min-width: 1.25rem" class="question-icon w-5 h-5 fill-white" name="circle" />
        <icon v-else class="question-icon w-5 h-5" :class="(choice.isWrong || choice.isCorrect) ? 'fill-white' : 'fill-secondary-400'" name="circle" />
        <span class="ml-2 w-100 block text-sm lg:text-base ">{{ choice.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  name: 'MultipleChoiceQuestion',

  components: {
    Icon,
  },

  props: {
    question: Object,
  },
  emits: ['update'],

  data() {
    return {
      selectedChoices: [],
    }
  },

  computed: {

    canBeSelected() {
      return ! this.question.wasAnswered
    },

    answersLimited() {
      return this.question.min_answers || this.question.max_answers
    },

    getAnswerLimit() {

      if (this.question.min_answers && this.question.max_answers) {
        return `Wählen Sie mindestens ${this.question.min_answers} und maximal ${this.question.max_answers} Antworten`
      }
      if (this.question.min_answers) {
        return `Wählen Sie mindestens ${this.question.min_answers} Antworten`
      }
      if (this.question.max_answers) {
        return `Wählen Sie bis zu ${this.question.max_answers} Antworten`
      }

      return false
    },
  },

  watch: {
    selectedChoices() {
      this.$emit('update', this.selectedChoices)
    },
  },

  methods: {

    answer() {

    },

    getChoiceClass( choice ) {

      if( choice.isCorrect || choice.isWrong ) {
        return [
          {'bg-green-500 text-white' : choice.isCorrect},
          {'bg-red-500 text-white' : choice.isWrong},
        ]
      } else if ( this.question.wasAnswered && !this.selectedChoices.includes( choice.id ) && choice.is_correct ) {
        return 'bg-green-100 text-green-700'
      } else if ( this.question.wasAnswered && choice.is_correct ) {
        return 'bg-primary-500 text-white'
      } else {
        return [
          this.selectedChoices.includes( choice.id ) ? 'bg-secondary-500 text-white' : 'bg-white',
        ]
      }
    },

    // select( value ){
    //   // this.selectedChoices = [ value ];
    // },
  },

}
</script>

<style scoped>
.question-icon {
  min-width: 1.25rem !important;
}
.icon--wrong {
  font-size: 1.5rem;
  line-height: 100%;
  left: 3px;
  position: relative;
}
</style>
